import routerOptions0 from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}